import { useState } from "react";
import { faqs } from "../../../mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于追瓜这件事"
          highlight="你可能想问"
          desc="关于热度怎么算、内容可不可信、能不能投稿等高频问题，都在这里一次说清。"
        />
        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-serif text-base font-bold text-foreground-950 md:text-lg">
                    <span className="mr-2 font-display text-sm text-primary-600">Q{i + 1}</span>
                    {f.q}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    <i className={`ri-add-line w-4 h-4 flex items-center justify-center transition-transform ${isOpen ? "rotate-45" : ""}`}></i>
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      <span className="mr-2 font-display text-sm text-primary-600">A</span>
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <p className="mt-6 text-center text-sm text-foreground-600">
          还有别的疑问？
          <a href="#contact" className="ml-1 font-semibold text-primary-600 underline-offset-4 hover:underline cursor-pointer">
            去投稿表单聊聊 →
          </a>
        </p>
      </div>
    </section>
  );
}